var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.isCommentDialogActivated
        ? _c(
            "div",
            { staticClass: "chat-popup text-left" },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c("input-text-area", {
                            attrs: {
                              id: "comentario-temporal-id",
                              label: _vm.$t(
                                "comentario-temporal.comentario.label"
                              ),
                              description: _vm.$t(
                                "comentario-temporal.comentario.description"
                              ),
                              readonly: false,
                              required: true,
                              rowsTextArea: 7,
                              valid: _vm.$v.comentarioTemporal.comentario.$dirty
                                ? !_vm.$v.comentarioTemporal.comentario.$error
                                : null,
                              validationsCommons: {
                                requiredValue:
                                  !_vm.$v.comentarioTemporal.comentario
                                    .required,
                                requiredMessage: _vm.$t(
                                  "comentario-temporal.comentario.validations.required"
                                ),
                                maxValue:
                                  !_vm.$v.comentarioTemporal.comentario
                                    .maxLength,
                                maxMessage: _vm.$t(
                                  "comentario-temporal.comentario.validations.maxMessage",
                                  { max: "4200" }
                                ),
                              },
                              maxCaracteres: 4200,
                            },
                            model: {
                              value:
                                _vm.$v.comentarioTemporal.comentario.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.comentarioTemporal.comentario,
                                  "$model",
                                  $$v
                                )
                              },
                              expression:
                                "$v.comentarioTemporal.comentario.$model",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { id: "add-comentario", variant: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.guardaComentario()
                            },
                          },
                        },
                        [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(_vm.$t("entity.action.save")),
                            },
                          }),
                          _vm._v(" "),
                          _c("font-awesome-icon", {
                            staticClass: "mr-2",
                            attrs: { icon: "save" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedRole === _vm.roleOperativoReniecyt &&
      _vm.routeName != "ConsultaRegistros" &&
      _vm.routeName != "Reportes" &&
      _vm.routeName != "ConsultaSubsedesRev"
        ? _c(
            "b-button",
            {
              staticClass: "floating-btn",
              attrs: { id: "comentario-secciones", variant: "primary" },
              on: {
                click: function ($event) {
                  return _vm.toggleComentario()
                },
              },
            },
            [
              _c("b-icon", {
                staticClass: "floating-btn--icon",
                attrs: {
                  icon: _vm.isCommentDialogActivated ? "x-lg" : "chat-left",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }